import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TournamentPickemDetails } from "model/PickemDetails/TournamentPickemDetails";

export interface IPickemDetailsSlice {
  intialLoadComplete: boolean;
  pickemDetails: { [key: string]: TournamentPickemDetails };
}

const initialState: IPickemDetailsSlice = {
  intialLoadComplete: false,
  pickemDetails: {},
};

export const pickemDetailsSlice = createSlice({
  name: "pickemDetails",
  initialState,
  reducers: {
    updatePickemDetails: (
      state,
      action: PayloadAction<{
        pickemDetails: TournamentPickemDetails[];
      }>
    ) => {
      const { pickemDetails } = action.payload;
      for (let i = 0; i < pickemDetails.length; i++) {
        const pickemDetials = pickemDetails[i];
        state.pickemDetails[pickemDetials.tournamentId] = pickemDetials;
      }

      if (!state.intialLoadComplete) {
        state.intialLoadComplete = true;
      }
    },
  },
});

export const { updatePickemDetails } = pickemDetailsSlice.actions;
export const pickemDetailsReducer = pickemDetailsSlice.reducer;
